import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { AutomationInterface } from '@vendasta/automata';

@Injectable({ providedIn: 'root' })
export class StepNameService {
  constructor(private readonly translateService: TranslateService) {}

  // Results in `name of step (num matching step names)`
  public buildBestAttemptUniqueName(name: string, automation: AutomationInterface): string {
    const translatedName = this.translateService.instant(name);
    const matchingNames = this.getNumberOfMatchingWorkflowNames(translatedName, automation);
    return translatedName + (matchingNames > 0 ? ` (${matchingNames + 1})` : '');
  }

  private getNumberOfMatchingWorkflowNames(name: string, automation: AutomationInterface): number {
    let total = 0;
    automation?.workflow?.forEach((w) => {
      if (w?.name?.includes(name)) {
        total++;
      }
    });
    return total;
  }
}
